import { css } from "../../../../../styled-system/css";

export const styles = {
  card: () =>
    css({
      display: "flex",
      alignItems: "center",
      gap: "baseUnit.mobile2",
      padding: "baseUnit.mobile2",
      borderRadius: "baseUnit.mobile2",
      cursor: "pointer",
      transition: "border-color 0.2s ease, background-color 0.2s ease",
      border: "1px solid",
      borderColor: "disabledGrey",
      backgroundColor: "white",
      _hover: {
        borderColor: "outlineGrey",
      },
      "&:has(:focus-visible)": {
        outlineWidth: "2px",
        outlineStyle: "solid",
        outlineColor: "oceanBlue",
        outlineOffset: "2px",
      },
      "&[data-selected=true]": {
        borderColor: "skyBlue",
        backgroundColor: "blueTintDark",
      },
      "&[data-selected=true]:hover": {
        borderColor: "skyBlue",
      },
    }),

  iconWrapper: () =>
    css({
      width: "32px",
      height: "32px",
      flexShrink: 0,
      color: "midnight",
      transition: "color 0.2s ease",
      "[data-selected=true] &": {
        color: "skyBlue",
      },
    }),

  description: () =>
    css({
      flex: 1,
      minWidth: 0,
      fontSize: "body.shrimp",
      fontWeight: 400,
      lineHeight: "body.shrimp",
      letterSpacing: "body.shrimp",
      color: "midnight",
    }),

  checkIcon: () =>
    css({
      width: "24px",
      height: "24px",
      flexShrink: 0,
    }),

  hiddenInput: () =>
    css({
      position: "absolute",
      width: "1px",
      height: "1px",
      padding: 0,
      margin: "-1px",
      overflow: "hidden",
      clip: "rect(0,0,0,0)",
      whiteSpace: "nowrap",
      borderWidth: 0,
    }),
};
